import type { SalesPoint } from '@/api/competitionDetail'
import { formatInteger } from '@/design'
import { formatDateKey } from '@/lib/filters'

import { statusLabel } from '../competitions/columns'

/* How the page's dates and counts read, in the tenant's timezone and locale. */

/** An instant as the tenant's day and time: "31 Oct 2026, 19:00". */
export function formatInstant(instant: string, timezone: string, locale: string | undefined): string {
  return new Date(instant).toLocaleString(locale ?? 'en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: timezone,
  })
}

/** Tenant days to a date, as the schedule gives them: "In 22 days", "Today", "3 days ago". */
export function formatDaysTo(days: number): string {
  if (days === 0) return 'Today'
  const count = Math.abs(days)
  const unit = `${formatInteger(count)} ${count === 1 ? 'day' : 'days'}`
  return days > 0 ? `In ${unit}` : `${unit} ago`
}

/** A tenant day (`YYYY-MM-DD`) with its year: "7 Oct 2026". (`../list/cells`' `formatDay` takes an instant.) */
export function formatDayKey(key: string): string {
  return formatDateKey(key, true)
}

/** A sales bucket's label: its day, or its first and last day for a week. */
export function bucketLabel(point: SalesPoint): string {
  return point.date === point.endDate ? formatDateKey(point.date) : `${formatDateKey(point.date)}–${formatDateKey(point.endDate)}`
}

/** An API word as a label, by the list's `statusLabel`, its underscores spaced: "on_hold" → "On hold". */
export function wordLabel(word: string): string {
  return statusLabel(word.replace(/_/g, ' '))
}
